<template>
  <div class="section section--404">
    <img src="../assets/img/jpg/404_headline.jpg" alt="The world is yours - EBANX" class="section__image" onload="this.classList.add('loaded')">

    <div class="container">
      <h1 class="section__title--summary">404 Error</h1>
      <h2 class="section__title">{{ $t('page404.title') }}</h2>

      <p class="section__message">{{ $t('page404.message.slice_1st') }} <router-link to="/">{{ $t('page404.message.homepage') }}</router-link> {{ $t('page404.message.slice_2nd') }} <a href="https://boards.greenhouse.io/ebanx" target="_blank">{{ $t('page404.message.open_positions') }}</a>.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Page404",
  methods: {
    viewOpeningTeam(team) {
      this.$store.dispatch("teams/currentTeam", team);
      this.$router.push({ name: "jobs" });
    }
  }
};
</script>
